export default __webpack_public_path__ + "static/media/rt-legends.b7b7a3a4.png";